import find from "lodash-es/find";

import { KEY } from "./reducer";

export const getState = (state) => state[KEY] || {};

export const getBlacklistsCollection = (state) => getState(state).items || {};

export const getBlacklistsById = (state, id) =>
    getBlacklistsCollection(state)[id];

export const getBlackList = (state) =>
    find(getBlacklistsCollection(state), ({ id }) => !!id);

export const getQuery = (state) => getState(state).query || "";
